import React from 'react';
import Modal from '../modal';
import Copy from '../../components/copy';
import { systemText } from '../../helpers/string';

import './deleteWarning.css';

export const DeleteWarning = ({
	id,
	show,
	title,
	message,
	close,
	mode,
	modalInModal,
	option,
	optionSelected,
	option2,
	optionSelected2,
	extra,
}) => {
	const [optSelected, setOptSelected] = React.useState(optionSelected);
	const [optSelected2, setOptSelected2] = React.useState(optionSelected2);

	const st = (path, ...rest) => systemText(`General/Controls/Warning/${path}`, ...rest);

	const footer = (
		<div>
			<button
				className={mode === 'confirm' ? 'btn btn-success' : 'btn btn-danger'}
				data-testid="button-warning-yes"
				onClick={() => close(true, optSelected, optSelected2)}
			>
				{st('Buttons/Yes')}
			</button>
			<button className="btn btn-default" data-testid="button-warning-no" onClick={() => close(false)}>
				{st('Buttons/No')}
			</button>
		</div>
	);

	return (
		<Modal
			show={show}
			modalInModal={modalInModal}
			title={title || mode === 'confirm' ? st('Title/Confirm') : st('Title/Warning')}
			close={() => close(false)}
			footer={footer}
		>
			<div className="delete-warning flex" data-testid={id ? `warning-${id}` : undefined}>
				<div>
					<i
						className={
							mode === 'confirm'
								? 'fa fa-question-circle fa-lg text-success'
								: 'fa fa-warning fa-lg text-danger'
						}
					/>
				</div>
				<div>
					<div className="copy" data-testid="warning-message">
						<Copy value={message} />
					</div>
					{option && (
						<div>
							<label className="mt10 flex flex-center warning-option">
								<input
									type="checkbox"
									checked={optSelected}
									onChange={e => setOptSelected(e.target.checked)}
								/>
								<span className="ml10">{option}</span>
							</label>
						</div>
					)}
					{option2 && (
						<div>
							<label className="mt10 flex flex-center warning-option">
								<input
									type="checkbox"
									checked={optSelected2}
									onChange={e => setOptSelected2(e.target.checked)}
								/>
								<span className="ml10">{option2}</span>
							</label>
						</div>
					)}
					{extra && extra()}
				</div>
			</div>
		</Modal>
	);
};

export default DeleteWarning;
